import type { FaireProductEntity } from "../../entity_types/product";

export const p_ggryz8hkzv: FaireProductEntity = {
  token: "p_ggryz8hkzv",
  type: "product",
  name: "Pure Arnica Salve",
  brandToken: "b_dowxrh2caf",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/324399e2c198938562222e4cf69cabd2eee2143110e362ad5380f725f6facd7c.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/cca109a85e8137503dae808af347dc8ce80691f9d1780137afd8dd5f27d89b67.png",
    "https://cdn.faire.com/fastly/a021b314435f1d9a4738361c4a728aa5e33959fb011d500065db66582107f642.png",
    "https://cdn.faire.com/fastly/98f10ec16fd3d94f793c23e0f0fee618e9b96900f44a9b9a0f86312bbfb47e45.png",
    "https://cdn.faire.com/fastly/520aaa115fb063239592a962b84c1a4bde7c2ce17cbcc4015b43bbfec7932a1c.png",
    "https://cdn.faire.com/fastly/6b680ac9d8c2ec4752155d3e99ece5d17ff8e53870c442ee3622d6167525d375.png",
    "https://cdn.faire.com/fastly/312d2dbd2bf47ce429ebcf1d894318cac731300021adc3aeeb5b42d97ce30dc5.png",
    "https://cdn.faire.com/fastly/a7a77a15b7dd15018607219e1ea7751c823738ae924161ec546f92f4b905bb98.png",
    "https://cdn.faire.com/fastly/d827f2f2b2b2a1cc9508ea0515cd11aafe58c1999f0ecd3416eff4c8a5819261.png",
    "https://cdn.faire.com/fastly/f908ca0795d3de6136c9b20a1c3127571649a0d32250c2e6dee5b518defafa9e.png",
    "https://cdn.faire.com/fastly/50c36c0dcad1adca7bab78f173b2ceca4438cfde3a81bceb7156bc3c55429df9.png",
  ],
  priceDollars: 13,
  description:
    "\nPure Arnica Salve helps relieve pain, bruising, swelling, strains and sprains. It's a great product to use directly on the skin to alleviate pain in cracked, bruised, or broken ribs, as well as for runners' injuries, joint pains, or tendon issues. Those healing from rotator cuff or other joint surgeries may find this product helpful.\n\nPremium organic Arnica (Arnica montana) blossoms are infused for a minimum of one month into organic golden Jojoba oil and organic unrefined Sunflower oil. This concentrated oil is used as the base for our salve. For an extra boost to your pain relief, try our Muscle Rub Salve.\n\nIngredients\n\n * Certified Organic Pure Arnica Infused Oil (organic Jojoba and Sunflower oils infused with organic Arnica flowers) \n * Certified Organic Shea (Vitellaria paradoxa) butter \n * Certified Organic Coconut (Cocos nucifera) oil \n * Certified Organic Beeswax \nWhat We ❤ About This Product\n\nSoothe your aches and pains away with this creamy, buttery salve that absorbs cleanly!",
  tags: [],
  msrpDollars: 26,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:25:42.924Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
